/**
 * @generated SignedSource<<1efa1263afb7dea826a12f2fc6299605>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RequiredLoginFieldsQuery$variables = {
  documentType: string;
};
export type RequiredLoginFieldsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RequiredLoginFields_query">;
};
export type RequiredLoginFieldsQuery = {
  response: RequiredLoginFieldsQuery$data;
  variables: RequiredLoginFieldsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "documentType"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "documentType",
    "variableName": "documentType"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disabilities",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preSignedUrl",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RequiredLoginFieldsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "RequiredLoginFields_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RequiredLoginFieldsQuery",
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Candidate",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "missingRequiredLoginFields",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaxID",
            "kind": "LinkedField",
            "name": "taxID",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taxID",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasDisability",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cvText",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "cvFile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "originalFileName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fileName",
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "company",
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "companyDomainName",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nameFriendly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "logo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "fitIn",
                    "value": true
                  }
                ],
                "kind": "ScalarField",
                "name": "url",
                "storageKey": "url(fitIn:true)"
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Document",
        "kind": "LinkedField",
        "name": "document",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Files",
            "kind": "LinkedField",
            "name": "files",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "label",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CandidateDocument",
        "kind": "LinkedField",
        "name": "candidateDocumentByDocumentType",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DocumentFile",
            "kind": "LinkedField",
            "name": "files",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "file",
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "File",
                "kind": "LinkedField",
                "name": "fileSchema",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyStatus",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ae23a48dbb3ab1b69796f2e8e21dac42",
    "id": null,
    "metadata": {},
    "name": "RequiredLoginFieldsQuery",
    "operationKind": "query",
    "text": "query RequiredLoginFieldsQuery(\n  $documentType: String!\n) {\n  ...RequiredLoginFields_query_vFxEu\n}\n\nfragment CVFileField_candidate on Candidate {\n  cvFile {\n    originalFileName\n    fileName\n    preSignedUrl\n    createdAt\n    url\n    id\n  }\n}\n\nfragment CVTextField_candidate on Candidate {\n  ...CVFileField_candidate\n}\n\nfragment CompanyLogo_company on Company {\n  nameFriendly\n  logo {\n    url(fitIn: true)\n    id\n  }\n}\n\nfragment DisabilitiesField_candidateDocument on CandidateDocument {\n  ...DocumentFormFile_candidateDocument\n}\n\nfragment DisabilitiesField_document on Document {\n  ...DocumentFormFile_document\n  files {\n    ...DocumentFormFile_file\n  }\n}\n\nfragment DisabilitiesField_query on Query {\n  disabilities\n  me {\n    ...DocumentFormFile_candidate\n    id\n  }\n}\n\nfragment DocumentFormFile_candidate on Candidate {\n  id\n}\n\nfragment DocumentFormFile_candidateDocument on CandidateDocument {\n  id\n  files {\n    file\n    name\n    fileSchema {\n      preSignedUrl\n      id\n    }\n  }\n}\n\nfragment DocumentFormFile_document on Document {\n  code\n}\n\nfragment DocumentFormFile_file on Files {\n  name\n  label\n}\n\nfragment RequiredLoginFields_query_vFxEu on Query {\n  ...DisabilitiesField_query\n  company: companyDomainName {\n    ...CompanyLogo_company\n    id\n  }\n  me {\n    id\n    name\n    missingRequiredLoginFields\n    taxID {\n      taxID\n    }\n    email\n    phone\n    hasDisability\n    disabilities\n    cvText\n    cvFile {\n      originalFileName\n      fileName\n      preSignedUrl\n      createdAt\n      url\n      id\n    }\n    ...CVTextField_candidate\n  }\n  document(documentType: $documentType) {\n    ...DisabilitiesField_document\n    code\n    files {\n      name\n      label\n    }\n  }\n  candidateDocumentByDocumentType(documentType: $documentType) {\n    ...DisabilitiesField_candidateDocument\n    id\n    companyStatus\n    files {\n      file\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b00abfd5e9878784ea57adfe0131a025";

export default node;
